module.exports = __webpack_public_path__ + "img/lrb_logo.a203c4b6.png";